<adaa-data-table
    titleHeader="international_projects.visits.delegation_members"
    [isLocalData]="true"
    [localData]="tableData"
    [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.INTP_COUNTRY_VISITS_MEMBERS_CONF_LIST"
    [enableAdd]="!isDisabled()"
    [enableEditAction]="!isDisabled()"
    [enableDeleteAction]="!isDisabled()"
    [enableExport]="false"
    (addNewClicked)="addNewClicked()"
    (actionClicked)="actionClicked($event)"
/>
